<template>
  <b-container
    :fluid="true"
    class="px-0"
    :style="{ margin: (loading || error) ? '0 !important' : 'auto'}"
    v-cloak
  >
    <form @submit.prevent="valid">
      <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
        <Loading />
      </div>
      <div v-else-if="error" class="min-vh-100 d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
          <h4 class="text-2xl text-gray-500 font-weight-bold">
            Manifest Not Found
          </h4>
          <p class="text-gray-700">
            Manifest with id <span class="badge badge-primary">{{ $route.params.id }}</span> could
            not be found. Make sure that there are no typos in the Manifest id.
          </p>
          <b-button
            class="d-flex align-items-center mx-auto"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left font-scale="0.8" />
            BACK
          </b-button>
        </div>
      </div>
      <b-row v-else class="px-3">
        <b-col
          cols="auto"
          class="pr-0 position-fixed d-none d-md-flex align-items-center"
          style="top: 10px; z-index: 1; height: calc(100vh - 20px);"
        >
          <div>
            <ShipmentNavProgress
              :card-names="cardNamesOrdered"
            ></ShipmentNavProgress>
          </div>
        </b-col>
        <b-col class="col ml-5" lg="8">
          <ShipmentPrototypeCard name="exporter" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>EXPORTER/SHIPPER</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporterFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="exporterFirst"
                      name="exporterFirst"
                      type="text"
                      v-model="response.exporterFirstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporterLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="exporterLast"
                      name="exporterLast"
                      type="text"
                      v-model="response.exporterLastName"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="exporter-address">
                    Address
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="exporter-address"
                    name="exporter-address"
                    type="text"
                    v-model="response.exporterAddress"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="exporter-country">
                    Country
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="exporter-country"
                    name="exporter-country"
                    type="text"
                    v-model="response.exporterCountry"
                  >
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporter-city">City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="exporter-city"
                      name="exporter-city"
                      type="text"
                      v-model="response.exporterCity"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporter-state">State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="exporter-state"
                      name="exporter-state"
                      type="text"
                      v-model="response.exporterState"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporter-zip-code">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="exporter-zip-code"
                      name="exporter-zip-code"
                      type="text"
                      v-model="response.exporterZipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="aes-itn">
                    AES ITN#
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="aes-itn"
                    name="aes-itn"
                    type="text"
                    v-model="response.aesITN"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="exporter-email">Email</label>
                  <input
                    required
                    class="form-control text-center"
                    id="exporter-email"
                    name="exporter-email"
                    type="email"
                    v-model="response.exporterEmail"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="exporter-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="exporter-phone"
                    name="exporter-phone"
                    type="text"
                    v-model="response.exporterPhone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="importer" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>IMPORTER/CONSIGNEE</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                 <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="importerFirst">
                      First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="importerFirst"
                      name="importerFirst"
                      type="text"
                      v-model="response.importerFirstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="importerLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="importerLast"
                      name="importerLast"
                      type="text"
                      v-model="response.importerLastName"
                    >
                  </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="importer-address">
                    Address
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="importer-address"
                    name="importer-address"
                    type="text"
                    v-model="response.importerAddress"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="importer-country">
                    Country
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="importer-country"
                    name="importer-country"
                    type="text"
                    v-model="response.importerCountry"
                  >
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="importer-city">City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="importer-city"
                      name="importer-city"
                      type="text"
                      v-model="response.importerCity"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="importer-state">State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="importer-state"
                      name="importer-state"
                      type="text"
                      v-model="response.importerState"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="importer-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="importer-zipcode"
                      name="importer-zipcode"
                      type="text"
                      v-model="response.importerZipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="importer-email">
                    Email
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="importer-email"
                    name="importer-email"
                    type="email"
                    v-model="response.importerEmail"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="importer-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="importer-phone"
                    name="importer-phone"
                    type="text"
                    v-model="response.importerPhone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="notify" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>NOTIFY PARTY</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="notify-party-First">
                      First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="notify-party-First"
                      name="notify-party-First"
                      type="text"
                      v-model="response.notifyPartyFirstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="notify-party-Last">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="notify-party-Last"
                      name="notify-party-Last"
                      type="text"
                      v-model="response.notifyPartyLastName"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="notifyParty-address">
                    Address
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="notify-party-address"
                    name="notify-party-address"
                    type="text"
                    v-model="response.notifyPartyAddress"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="notify-party-country">
                    Country
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="notify-party-country"
                    name="notify-party-country"
                    type="text"
                    v-model="response.notifyPartyCountry"
                  >
                </div>

                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="notify-party-city">
                      City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="notify-party-city"
                      name="notify-party-city"
                      type="text"
                      v-model="response.notifyPartyCity"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="notify-party-state">
                      State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="notify-party-state"
                      name="notify-party-state"
                      type="text"
                      v-model="response.notifyPartyState"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="notify-party-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="notify-party-zipcode"
                      name="notify-party-zipcode"
                      type="text"
                      v-model="response.notifyPartyZipCode"
                    >
                  </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="notify-party-email">
                    Email
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="notify-party-email"
                    name="notify-party-email"
                    type="email"
                    v-model="response.notifyPartyEmail"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="notify-party-phone">
                    Phone
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="notify-party-phone"
                    name="notify-party-phone"
                    type="text"
                    v-model="response.notifyPartyPhone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="forward"
          :visible='false' v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>FORWARDING AGENT</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="forwarding-agent-First">
                      First Name
                    </label>
                    <input
                      class="form-control text-center"
                      id="forwarding-agent-First"
                      name="forwarding-agent-First"
                      type="text"
                      v-model="response.forwardingAgentFirstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="forwarding-agent-Last">
                      Last Name</label>
                    <input
                      class="form-control text-center"
                      id="forwarding-agent-Last"
                      name="forwarding-agent-Last"
                      type="text"
                      v-model="response.forwardingAgentLastName"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="forwarding-agent-email">
                    Email
                  </label>
                  <input
                    class="form-control text-center"
                    id="forwarding-agent-email"
                    name="forwarding-agent-email"
                    type="email"
                    v-model="response.forwardingAgentEmail"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="forwarding-agent-phone">
                    Phone
                  </label>
                  <input
                    class="form-control text-center"
                    id="forwarding-agent-phone"
                    name="forwarding-agent-phone"
                    type="text"
                    v-model="response.forwardingAgentPhone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="shipping" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>SHIPPING</h6>
            </template>
            <template v-slot:body>
              <div class="pb-3">
                <div class="mx-5">
                  <div>
                    <div v-if="$route.params.id">
                      <label class="col-form-label floating-label" for="bill-of-lading">
                        Booking #
                      </label>
                      <label class="form-control col-form-label floating-label"
                      for="bill-of-lading">{{ response.billOfLading }}
                      </label>
                    </div>
                    <div v-else>
                      <label class="col-form-label floating-label" for="bill-of-lading">
                        Booking #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="billOfLading"
                        name="billOfLading"
                        type="text"
                        v-model="response.billOfLading"
                      >
                    </div>
                    <!-- <label class="form-control text-center">
                      {{response.billOfLading}}
                    </label> -->
                  </div>
                  <div class="floating-label-container">
                    <div v-if="$route.params.id">
                      <label class="col-form-label floating-label" for="fileno">
                        BOL File #
                      </label>
                      <label class="form-control col-form-label floating-label" for="fileno">
                        {{ response.fileno }}
                      </label>
                    </div>
                    <div v-else>
                      <label class="col-form-label floating-label" for="fileno">
                        BOL File #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="fileno"
                        name="fileno"
                        type="text"
                        v-model="response.fileno"
                      >
                    </div>
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="prepaid">
                      Prepaid
                    </label>
                    <input
                      class="form-control text-center"
                      id="prepaid"
                      name="prepaid"
                      type="text"
                      v-model="response.prepaid"
                    >
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="delivery-type">
                      Delivery Type
                    </label>
                    <b-form-select
                      required
                      id="delivery-type"
                      v-model="response.deliveryType"
                      :options="deliveryTypes"
                      class="text-center"
                    ></b-form-select>
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="exporter-reference">
                      Exporter Reference
                    </label>
                    <input
                      class="form-control text-center"
                      id="exporter-reference"
                      name="exporter-reference"
                      type="text"
                      v-model="response.exporterReference"
                    >
                  </div>
                </div>
                <hr/>
                <div class="mx-5">
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="pre-carriage">
                      Pre-carriage
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="pre-carriage"
                      name="pre-carriage"
                      type="text"
                      v-model="response.preCarriage"
                    >
                  </div>
                  <b-row>
                    <b-col class="floating-label-container">
                     <label class="col-form-label floating-label" for="exporting-carrier">
                      Exporting Carrier
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="exporting-carrier"
                        name="exporting-carrier"
                        type="text"
                        v-model="response.exportingCarriage"
                      >
                    </b-col>
                    <b-col class="floating-label-container">
                      <label class="col-form-label floating-label" for="exporting-Scac">SCAC
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="exporting-Scac"
                        name="exporting-Scac"
                        type="text"
                        v-model="response.exportingScac"
                      >
                    </b-col>
                  </b-row>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="vessel-voyage">
                      Vessel/Voyage
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="vessel-voyage"
                      name="vessel-voyage"
                      type="text"
                      v-model="response.vessel"
                    >
                  </div>
                </div>
                <hr/>
                <div class="mx-5">
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="origin">
                      Origin
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="origin"
                      name="origin"
                      type="text"
                      v-model="response.origin"
                    >
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="loading-port">
                      Loading Port
                    </label>
                    <input
                      class="form-control text-center"
                      id="loading-port"
                      name="loading-port"
                      type="text"
                      v-model="response.loadingPort"
                    >
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="loading-pier">
                      Loading Pier
                    </label>
                    <input
                      class="form-control text-center"
                      id="loading-pier"
                      name="loading-pier"
                      type="text"
                      v-model="response.loadingPier"
                    >
                  </div>
                </div>
                <hr/>
                <div class="mx-5">
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="destination">
                      Destination
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="destination"
                      name="destination"
                      type="text"
                      v-model="response.destination"
                      @change="loadWarehouse()"
                    >
                  </div>
                  <div class="floating-label-container">
                    <label class="col-form-label floating-label" for="unloading-port">
                      Unloading Port
                    </label>
                    <input
                      class="form-control text-center"
                      id="unloading-port"
                      name="unloading-port"
                      type="text"
                      v-model="response.unloadingPort"
                    >
                  </div>
                </div>
                <hr/>
                <div class="mx-5">
                  <div class="floating-label-container">
                    <div class="d-inline-block">
                      <label class="col-form-label floating-label" for="shipped-date">
                        Shipped Date
                      </label>
                      <div>
                        <div class="d-inline-block">
                          <b-form-datepicker
                            required
                            reset-button
                            v-model="response.shippedDate"
                            class="normalize text-center"
                            :max="maxStartDate"
                            :state="isStartDateValid"
                          ></b-form-datepicker>
                        </div>
                        <div class="d-inline-block">
                          <b-form-timepicker
                            required
                            reset-button
                            v-model="shippedTime"
                            :state="isStartTimeValid"
                            class="normalize"
                            locale="en"
                          ></b-form-timepicker>
                        </div>
                      </div>
                    </div>
                    <div class="d-inline-block">
                      <p>&nbsp;-&nbsp;</p>
                      <br>
                    </div>
                    <div class="d-inline-block">
                      <label class="col-form-label floating-label" for="arrival-date">
                        Arrival Date
                      </label>
                      <div>
                        <div class="d-inline-block">
                          <b-form-datepicker
                            required
                            reset-button
                            v-model="response.arrivalDate"
                            class="normalize text-center"
                            :min="minEndDate"
                             :state="isEndDateValid"
                          ></b-form-datepicker>
                        </div>
                        <div class="d-inline-block">
                          <b-form-timepicker
                            required
                            reset-button
                            v-model="arrivalTime"
                            :state="isEndTimeValid"
                            class="normalize"
                            locale="en"
                          ></b-form-timepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="warehouse" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>WAREHOUSE</h6>
            </template>
            <template v-slot:body>
              <div class="px-5">
                <ContainerWidget
                :items="response.items"
                :billOfLading="response.billOfLading"
                :loadingFlag="warehouseLoading"
                >
                </ContainerWidget>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <!-- <ShipmentPrototypeCard name="notes" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>NOTES</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <div>
                  <label class="col-form-label floating-label" for="commodity-description">
                    Commodity Description
                  </label>
                  <input
                    class="form-control text-center"
                    id="commodity-description"
                    name="commodity-description"
                    type="text"
                    v-model="response.description"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard> -->
          <ShipmentPrototypeCard name="notes" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>NOTES</h6>
            </template>
            <template v-slot:body>
              <ContainerPrototypeItemList
                :items="response.warehouseItems"
                @add="addNewItem"
                @remove="removeItem"
              ></ContainerPrototypeItemList>
            </template>
          </ShipmentPrototypeCard>
          <div v-if="$route.params.id">
            <ShipmentPrototypeCard name="update" v-observe-visibility="visibilityChanged">
              <template v-slot:title>
                <h6>FINAL STEP</h6>
              </template>
              <template v-slot:body>
                <b-button type="update" block class="mb-2 shipment-create-button w-50 m-auto">
                  <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                  UPDATE MANIFEST
                </b-button>
              </template>
            </ShipmentPrototypeCard>
          </div>
          <div v-else>
            <ShipmentPrototypeCard name="submit" v-observe-visibility="visibilityChanged">
              <template v-slot:title>
                <h6>FINAL STEP</h6>
              </template>
              <template v-slot:body>
                <b-button type="create" block class="mb-2 shipment-create-button w-50 m-auto">
                  <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                  CREATE MANIFEST
                </b-button>
              </template>
            </ShipmentPrototypeCard>
          </div>
        </b-col>
        <b-col col class="h-100 position-sticky d-none d-lg-block" style="top: 10px;">
          <ShipmentPrototypeCard name="summary">
            <template v-slot:title>
              <h6 class="font-weight-bold">SUMMARY</h6>
            </template>
            <template v-slot:body>
              <hr class="mt-0"/>
              <div v-if="response.exporterFirstName && response.importerFirstName">
                <div>
                  {{ `${response.exporterFirstName} ${response.exporterLastName}` }}
                  <b-icon-arrow-right></b-icon-arrow-right>
                  {{ `${response.importerFirstName} ${response.importerLastName}` }}
                </div>
                <hr/>
              </div>
              <div v-if="response.origin && response.destination">
                <div>
                  {{ response.origin }}
                  <b-icon-arrow-right></b-icon-arrow-right>
                  {{ response.destination }}
                </div>
                <hr class="mb-0"/>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <div v-if="$route.params.id">
            <b-button type="updateManifest" block class="shadow-sm mb-2 shipment-create-button">
              <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
              UPDATE MANIFEST
            </b-button>
          </div>
          <div v-else>
            <b-button type="createManifest" block class="shadow-sm mb-2 shipment-create-button">
              <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
              CREATE MANIFEST
            </b-button>
          </div>
          <div class="d-inline-flex mt-2">
            <b-button @click="reset" class="shipment-option" title="New Shipment">
              <b-icon-plus></b-icon-plus>
            </b-button>
            <b-button @click="copy" class="shipment-option" title="Copy to New">
              <b-icon-files></b-icon-files>
            </b-button>
            <b-button
              v-b-modal.print
              class="shipment-option"
              title="Print"
            >
              <b-icon-printer></b-icon-printer>
            </b-button>

             <b-modal id="print" ref="printModal" title="Manifest Files" hide-footer>

                <b-button
                  block class="shadow-sm mb-2 shipment-create-button"
                  @click="hideModal($refs.pdf1);"
                  title="Manifest"
                >
                  Manifest
                </b-button>

                <b-button
                  block class="shadow-sm mb-2 shipment-create-button"
                  @click="hideModal($refs.pdf2);"
                  title="Bill of Lading"
                >
                 Bill of Lading
                </b-button>
              </b-modal>

              <b-modal id="confirmation" ref="confirmationModal" centered title="" hide-footer
              hide-header>
                <div v-if="processing">
                  <Loading />
                </div>
                <div v-else-if="processingError">
                  <div class="d-flex align-items-center justify-content-center">
                    <Cross />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Failure</h2>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    {{ processingError }}
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex align-items-center justify-content-center">
                    <Checkmark />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Done!</h2>
                  </div>
                </div>
              </b-modal>
          </div>
        </b-col>
      </b-row>
    </form>
    <PrintManifest name="html2Pdf" ref="pdf1" />
    <PanBL name="html2Pdf" :response="response" ref="pdf2" />
  </b-container>
</template>

<script>
import { nanoid } from 'nanoid';
import PanBL from '../components/PanBL.vue';
import PrintManifest from '../components/PrintManifest.vue';
import ShipmentPrototypeCard from '../components/ShipmentPrototypeCard.vue';
import ShipmentNavProgress from '../components/ShipmentNavProgress.vue';
import ContainerPrototypeItemList from '../components/ContainerPrototypeItemList.vue';
import ContainerWidget from '../components/ContainerWidget.vue';
import Loading from '../components/Loading.vue';
import Checkmark from '../components/Checkmark.vue';
import Cross from '../components/Cross.vue';
import {
  postManifest, editManifest, getManifestById, warehouse,
} from '../api/manifest';

export default {
  name: 'ShipmentPrototype',
  data() {
    return this.initialState();
  },
  computed: {
    cardNamesOrdered() {
      return Object.values(this.cardNames).sort((a, b) => a.order - b.order);
    },
    mostCommonReference() {
      const counter = {};
      this.items.forEach((elem) => {
        if (elem.reference in counter) {
          counter[elem.reference] += elem.amount;
        } else {
          counter[elem.reference] = elem.amount;
        }
      });

      let max = -1;
      let maxRef = '';
      Object.entries(counter).forEach(([key, val]) => {
        if (val >= max) {
          maxRef = key;
          max = val;
        }
      });
      return max === -1 ? '...' : `${maxRef}...`;
    },
    totalCount() {
      return this.items.reduce((acc, curr) => acc + curr.amount, 0);
    },
    totalWeight() {
      return this.items.reduce((acc, curr) => acc + curr.weight, 0);
    },
    totalVolume() {
      return this.items.reduce((acc, curr) => acc + curr.volume, 0);
    },
    outstandingBalance() {
      return this.charges.reduce((acc, curr) => acc + curr.amount, 0)
                    - this.payments.reduce((acc, curr) => acc + curr.amount, 0);
    },
    minEndDate() {
      return this.response.shippedDate;
    },
    maxStartDate() {
      return this.response.arrivalDate;
    },
  },
  methods: {
    initialState() {
      return {
        deliveryTypes: [
          { value: 'porttoport', text: 'port to port' },
          { value: 'preclearance', text: 'pre-clearance' },
          { value: 'doortodoor', text: 'door to door' },
        ],
        warehouseLoading: false,
        arrivalTime: '',
        shippedTime: '',
        isStartDateValid: null,
        isEndDateValid: null,
        isStartTimeValid: null,
        isEndTimeValid: null,
        response: {
          items: {
            warehouse: [],
            container: [],
          },
          warehouseItems: [
            {
              id: 0,
              qty: '',
              commodity: '',
              description: '',
              flag: true,
            },
          ],
          exporterFirstName: '',
          exporterLastName: '',
          exporterAddress: '',
          exporterCountry: '',
          exporterCity: '',
          exporterState: '',
          exporterZipCode: '',
          exporterPhone: '',
          exporterEmail: '',
          forwardingAgentFirstName: '',
          forwardingAgentLastName: '',
          forwardingAgentPhone: '',
          forwardingAgentEmail: '',
          importerFirstName: '',
          importerLastName: '',
          importerAddress: '',
          importerCountry: '',
          importerCity: '',
          importerState: '',
          importerZipCode: '',
          importerPhone: '',
          importerEmail: '',
          notifyPartyFirstName: '',
          notifyPartyLastName: '',
          notifyPartyAddress: '',
          notifyPartyCountry: '',
          notifyPartyCity: '',
          notifyPartyState: '',
          notifyPartyZipCode: '',
          notifyPartyPhone: '',
          notifyPartyEmail: '',
          billOfLading: '',
          exporterReference: '',
          preCarriage: '',
          exportingCarriage: '',
          exportingScac: '',
          vessel: '',
          voyage: '',
          loadingPort: '',
          loadingPier: '',
          unloadingPort: '',
          deliveryType: '',
          origin: '',
          destination: '',
          prepaid: '',
          fileno: '',
          arrivalDate: '',
          shippedDate: '',
          // Put warehouse stuff here
          containerSize: '',
          containerNumber: '',
          aesITN: '',
          seal: '',
          description: '',
        },
        loading: true,
        processing: false,
        processingError: false,
        error: false,
        cardNames: {
          exporter: {
            order: 0,
            title: 'Exporter',
            id: 'exporter',
            visible: false,
          },
          importer: {
            order: 1,
            title: 'Importer',
            id: 'importer',
            visible: false,
          },
          notify: {
            order: 2,
            title: 'Notify Party',
            id: 'notify',
            visible: false,
          },
          forward: {
            order: 3,
            title: 'Forwarding Agent',
            id: 'forward',
            visible: true,
          },
          shipping: {
            order: 4,
            title: 'Shipping',
            id: 'shipping',
            visible: false,
          },
          warehouse: {
            order: 5,
            title: 'Warehouse',
            id: 'warehouse',
            visible: false,
          },
          // marks: {
          //   order: 6,
          //   title: 'Marks',
          //   id: 'marks',
          //   visible: false,
          // },
          notes: {
            order: 6,
            title: 'Notes',
            id: 'notes',
            visible: false,
          },
          submit: {
            order: 7,
            title: 'Finish',
            id: 'submit',
            visible: false,
          },
        },
      };
    },
    loadWarehouse() {
      if (this.response.destination !== '') {
        this.warehouseLoading = true;
        warehouse(this.response.destination.trim())
          .then((resp) => {
            console.log('Successfully GETed');
            console.log(resp);
            this.warehouseLoading = false;
            this.response.items.warehouse = resp.data.results;
          }).catch((err) => {
            console.log(err);
          });
      }
    },
    reset() {
      Object.assign(this.$data, this.initialState());
      delete this.$route.params.id;
      window.history.pushState({}, null, '#/manifest-proto');
      this.loading = false;
    },
    copy() {
      const copy = this.$data.response;
      Object.assign(this.$data, this.initialState());
      this.response.exporterFirstName = copy.exporterFirstName;
      this.response.exporterLastName = copy.exporterLastName;
      this.response.exporterAddress = copy.exporterAddress;
      this.response.exporterCountry = copy.exporterCountry;
      this.response.exporterCity = copy.exporterCity;
      this.response.exporterState = copy.exporterState;
      this.response.exporterZipCode = copy.exporterZipCode;
      this.response.exporterPhone = copy.exporterPhone;
      this.response.exporterEmail = copy.exporterEmail;
      this.response.aesITN = copy.aesITN;
      this.response.forwardingAgentFirstName = copy.forwardingAgentFirstName;
      this.response.forwardingAgentLastName = copy.forwardingAgentLastName;
      this.response.forwardingAgentPhone = copy.forwardingAgentPhone;
      this.response.forwardingAgentEmail = copy.forwardingAgentEmail;
      this.response.importerFirstName = copy.importerFirstName;
      this.response.importerLastName = copy.importerLastName;
      this.response.importerAddress = copy.importerAddress;
      this.response.importerCountry = copy.importerCountry;
      this.response.importerCity = copy.importerCity;
      this.response.importerState = copy.importerState;
      this.response.importerZipCode = copy.importerZipCode;
      this.response.importerPhone = copy.importerPhone;
      this.response.importerEmail = copy.importerEmail;
      this.response.notifyPartyFirstName = copy.notifyPartyFirstName;
      this.response.notifyPartyLastName = copy.notifyPartyLastName;
      this.response.notifyPartyPhone = copy.notifyPartyPhone;
      this.response.notifyPartyEmail = copy.notifyPartyEmail;
      this.response.notifyPartyAddress = copy.notifyPartyAddress;
      this.response.notifyPartyCountry = copy.notifyPartyCountry;
      this.response.notifyPartyCity = copy.notifyPartyCity;
      this.response.notifyPartyState = copy.notifyPartyState;
      this.response.notifyPartyZipCode = copy.notifyPartyZipCode;
      delete this.$route.params.id;
      window.history.pushState({}, null, '#/manifest-proto');
      this.loading = false;
    },
    createManifest() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      copy.arrivalDate = `${copy.arrivalDate} ${this.arrivalTime}`;
      copy.shippedDate = `${copy.shippedDate} ${this.shippedTime}`;
      copy.warehouseItems = copy.warehouseItems.map(({ id, ...rest }) => rest);
      const test = Object.keys(copy).reduce((acc, curr) => {
        if (typeof copy[curr] === 'string') {
          acc[curr] = copy[curr].trim();
        } else {
          acc[curr] = copy[curr];
        }
        return acc;
      }, {});
      const data = { data: { ...test } };
      postManifest(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          this.$router.push(`/manifest-proto/${resp.data.id}`);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
        });
    },
    updateManifest() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      copy.arrivalDate = `${copy.arrivalDate} ${this.arrivalTime}`;
      copy.shippedDate = `${copy.shippedDate} ${this.shippedTime}`;
      const test = Object.keys(copy).reduce((acc, curr) => {
        if (typeof copy[curr] === 'string') {
          acc[curr] = copy[curr].trim();
        } else {
          acc[curr] = copy[curr];
        }
        return acc;
      }, {});
      const data = { data: { ...test } };
      editManifest(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          setTimeout(() => this.$router.go(0), 1000);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
        });
    },
    visibilityChanged(isVisible, entry) {
      if (Object.prototype.hasOwnProperty.call(this.cardNames, entry.target.id)) {
        this.cardNames[entry.target.id].visible = isVisible;
      }
    },
    addNewItem() {
      this.response.warehouseItems.push({
        id: nanoid(6),
        qty: '',
        commodity: '',
        description: '',
        flag: true,
      });
    },
    removeItem(id) {
      this.response.warehouseItems.find(
        (item) => item.id === id,
      ).flag = false;
      // this.response.warehouseItems.splice(this.response.warehouseItems.findIndex(
      //   (item) => item.id === id,
      // ), 1);
    },
    valid() {
      let flag = false;

      this.isStartDateValid = this.response.shippedDate !== '' ? null : false;
      if (this.isStartDateValid === false) {
        flag = true;
      }

      this.isEndDateValid = this.response.arrivalDate !== '' ? null : false;
      if (this.isEndDateValid === false) {
        flag = true;
      }

      this.isStartTimeValid = this.shippedTime !== '' ? null : false;
      if (this.isStartTimeValid === false) {
        flag = true;
      }
      this.isEndTimeValid = this.arrivalTime !== '' ? null : false;
      if (this.isEndTimeValid === false) {
        flag = true;
      }

      if (flag) {
        return;
      }

      if (this.response.items.container.length === 0) {
        this.processingError = 'Need to add a container';
        this.$refs.confirmationModal.show();
        return;
      }

      this.response.items.container.forEach((containerObj) => {
        if (containerObj.item.length === 0) {
          flag = true;
          this.processingError = 'Need to add at least one shipment inside a container';
          this.$refs.confirmationModal.show();
        }
      });

      if (flag) {
        return;
      }

      if (this.$route.params.id) {
        this.updateManifest();
      } else {
        this.createManifest();
      }
    },
    toggleHazard(idx) {
      const item = this.items.find((elem) => elem.id === idx);
      item.hazardous = !item.hazardous;
    },
    hideModal(file) {
      this.$refs.printModal.hide();
      file.generatePdf();
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      if (toDepth < fromDepth) {
        this.reset();
      }
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();

    if (this.$route.params.id) {
      getManifestById(this.$route.params.id)
        .then((res) => {
          this.response.items.container = res.data.result.containers;
          this.response.exporterFirstName = res.data.result.exporter.firstName;
          this.response.exporterLastName = res.data.result.exporter.lastName;
          this.response.exporterAddress = res.data.result.exporter.address;
          this.response.exporterCountry = res.data.result.exporter.country;
          this.response.exporterCity = res.data.result.exporter.city;
          this.response.exporterState = res.data.result.exporter.state;
          this.response.exporterZipCode = res.data.result.exporter.zipCode;
          this.response.exporterPhone = res.data.result.exporter.phone;
          this.response.exporterEmail = res.data.result.exporter.email;
          this.response.aesITN = res.data.result.exporter.aesITN;
          this.response.forwardingAgentFirstName = res.data.result.forwardingAgent.firstName;
          this.response.forwardingAgentLastName = res.data.result.forwardingAgent.lastName;
          this.response.forwardingAgentPhone = res.data.result.forwardingAgent.phone;
          this.response.forwardingAgentEmail = res.data.result.forwardingAgent.email;
          this.response.importerFirstName = res.data.result.importer.firstName;
          this.response.importerLastName = res.data.result.importer.lastName;
          this.response.importerAddress = res.data.result.importer.address;
          this.response.importerCountry = res.data.result.importer.country;
          this.response.importerCity = res.data.result.importer.city;
          this.response.importerState = res.data.result.importer.state;
          this.response.importerZipCode = res.data.result.importer.zipCode;
          this.response.importerPhone = res.data.result.importer.phone;
          this.response.importerEmail = res.data.result.importer.email;
          this.response.notifyPartyFirstName = res.data.result.notifyParty.firstName;
          this.response.notifyPartyLastName = res.data.result.notifyParty.lastName;
          this.response.notifyPartyAddress = res.data.result.notifyParty.address;
          this.response.notifyPartyCountry = res.data.result.notifyParty.country;
          this.response.notifyPartyCity = res.data.result.notifyParty.city;
          this.response.notifyPartyState = res.data.result.notifyParty.state;
          this.response.notifyPartyZipCode = res.data.result.notifyParty.zipCode;
          this.response.notifyPartyPhone = res.data.result.notifyParty.phone;
          this.response.notifyPartyEmail = res.data.result.notifyParty.email;
          this.response.billOfLading = res.data.result.billOfLading;
          this.response.exporterReference = res.data.result.manifestDetails.exporterReference;
          this.response.preCarriage = res.data.result.manifestDetails.preCarriage;
          this.response.exportingCarriage = res.data.result.manifestDetails.exportingCarriage;
          this.response.exportingScac = res.data.result.manifestDetails.exportingScac;
          this.response.vessel = res.data.result.manifestDetails.vessel;
          this.response.loadingPort = res.data.result.manifestDetails.loadingPort;
          this.response.loadingPier = res.data.result.manifestDetails.loadingPier;
          this.response.unloadingPort = res.data.result.manifestDetails.unloadingPort;
          this.response.deliveryType = res.data.result.manifestDetails.deliveryType;
          this.response.origin = res.data.result.manifestDetails.origin;
          this.response.destination = res.data.result.manifestDetails.destination;
          this.response.prepaid = res.data.result.manifestDetails.prepaid;
          this.response.fileno = res.data.result.manifestDetails.fileno;
          this.response.arrivalDate = new Date(res.data.result.manifestDetails.arrivalDate);
          this.response.shippedDate = new Date(res.data.result.manifestDetails.shippedDate);
          this.response.description = res.data.result.manifestDetails.description;
          this.response.warehouseItems = res.data.result.manifestDetails.warehouseItems;
          this.arrivalTime = this.response.arrivalDate.toLocaleTimeString(
            'en',
            { hour12: false, timeZone: 'UTC' },
          );
          this.shippedTime = this.response.shippedDate.toLocaleTimeString(
            'en',
            { hour12: false, timeZone: 'UTC' },
          );
          // eslint-disable-next-line prefer-destructuring
          this.response.arrivalDate = this.response.arrivalDate.toISOString().split('T')[0];
          // eslint-disable-next-line prefer-destructuring
          this.response.shippedDate = this.response.shippedDate.toISOString().split('T')[0];
          // this.response = res.data.result;
          this.loadWarehouse();
          this.loading = false;
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    } else {
      this.loading = false;
      this.error = false;
    }
  },
  components: {
    ContainerPrototypeItemList,
    ContainerWidget,
    ShipmentNavProgress,
    ShipmentPrototypeCard,
    PanBL,
    PrintManifest,
    Loading,
    Checkmark,
    Cross,
  },
};
</script>

<style scoped>
/*@import '../assets/styles/floatingLabel.scss';*/
</style>

<style>
html {
  scroll-behavior: smooth;
}

.shipment-create-button {
  background: #7da3c7;
  border: none;
}

.shipment-create-button:hover {
  background: #608cb3;
}

.shipment-option {
  height: 3em;
  width: 3em;
  padding: 0;
  border-radius: 50%;
  margin: 0 10px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  background: #7da3c7;
  outline: none;
  border: none;
}

.shipment-option:hover {
  background: #608cb3;
}
</style>
